import { imageSource } from "@app/constants/image-sources";

export const visionData = [
  {
    image: imageSource.vision1,
    title: "Vision",
    description:
      "To be Bengaluru's most trusted destination for luxury pre-owned cars, where ownership begins with transparency and continues with peace of mind.",
  },
  {
    image: imageSource.vision2,
    title: "Mission",
    description:
      "To provide the people of Karnataka state-of-the-art, reliable, comfortable and safe mobility to ensure Mass Happiness",
  },
  {
    image: imageSource.vision3,
    title: "Sustainable Future",
    description:
      "We are committed to eco-friendly practices, building a future where mobility and responsibility go hand in hand.",
  },
];
